/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import * as stores from "stores";

class UIUpdater {
  constructor() {
    // Object to store handlers for each key
    this.handlers = {
      pages: this.handlePages.bind(this)
      // Add more handlers here if needed in the future
    };
  }

  async performUIUpdates(updates) {
    const promises = [];

    for (const [key, values] of Object.entries(updates.data)) {
      const handler = this.handlers[key];
      if (handler) {
        // Call the handler and add its returned promise(s) to the list
        const result = handler(values);
        // Ensure the result is always added as a promise
        if (Array.isArray(result)) {
          promises.push(...result);
        } else {
          promises.push(result);
        }
      }
    }

    await Promise.all(promises);
    return true;
  }

  async handlePages(pageNumList) {
    return stores.documentStore.reloadPageListAndGeometries(pageNumList, {
      refreshGeometry: false
    });
  }
}

const uiUpdater = new UIUpdater();
export const performUIUpdates = uiUpdater.performUIUpdates.bind(uiUpdater);
